import type { AuthContextResponse } from '@/types/auth_context';
import { getTenantOverrideState } from './tenant_override_store';

type AuthContextListener = (context: AuthContextResponse | null) => void;

let authContextState: AuthContextResponse | null = null;
const listeners = new Set<AuthContextListener>();

const syncCompatibilityStorage = (context: AuthContextResponse | null) => {
  if (typeof window === 'undefined') {
    return;
  }

  const tenantOverride = getTenantOverrideState();
  const tenantId = tenantOverride?.tenantId?.trim() || context?.tenantId?.trim() || '';
  const organizationId =
    tenantOverride?.organizationId?.trim() ||
    context?.organizationId?.trim() ||
    tenantId;
  const workspaceId = context?.workspaceId?.trim() || '';

  if (tenantId.length > 0) {
    localStorage.setItem('tenantid', tenantId);
    localStorage.setItem('tenantId', tenantId);
  } else {
    localStorage.removeItem('tenantid');
    localStorage.removeItem('tenantId');
  }

  if (organizationId.length > 0) {
    localStorage.setItem('organizationid', organizationId);
    localStorage.setItem('organizationId', organizationId);
  } else {
    localStorage.removeItem('organizationid');
    localStorage.removeItem('organizationId');
  }

  if (workspaceId.length > 0) {
    localStorage.setItem('workspaceId', workspaceId);
  } else {
    localStorage.removeItem('workspaceId');
  }
};

const notifyListeners = () => {
  listeners.forEach((listener) => listener(authContextState));
};

export const setAuthContextState = (context: AuthContextResponse | null) => {
  authContextState = context;
  syncCompatibilityStorage(context);
  notifyListeners();
};

export const getAuthContextState = () => authContextState;

export const clearAuthContextState = () => {
  setAuthContextState(null);
};

export const subscribeAuthContextState = (listener: AuthContextListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

